import { APIFactory } from '../../ui-toolkit/rest/APIFactory';
import { axiosErrorHandler } from '../../ui-toolkit/rest/axiosErrorHandler';
import { baseUrlService } from '../../ui-toolkit/rest/BaseUrlService';
import { IConversationData, IConversationResponse } from '../../types/conversations/IConversation';

export const getConversationAsync = async (id: string): Promise<IConversationData> =>
  APIFactory(baseUrlService.ApiLocation)
    .get<IConversationResponse>(`/timber/api/internal/genesys/conversations/${id}`)
    .then((response) => response.data)
    .catch(axiosErrorHandler);
